<template>
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.5 0C2.46243 0 0 2.43756 0 5.44444C0 8.28504 1.70064 10.5612 4.94442 13.7722C5.25126 14.0759 5.74874 14.0759 6.05558 13.7722C9.29937 10.5612 11 8.28504 11 5.44444C11 2.43756 8.53757 0 5.5 0ZM5.5 7.77778C6.80181 7.77778 7.85714 6.73311 7.85714 5.44444C7.85714 4.15578 6.80181 3.11111 5.5 3.11111C4.19819 3.11111 3.14286 4.15578 3.14286 5.44444C3.14286 6.73311 4.19819 7.77778 5.5 7.77778Z"
      fill="#DF252A"
    />
  </svg>
</template>
